export default {
  linkedin:
    '<a href="https://www.linkedin.com/in/daniel-briffa" target="_blank">https://www.linkedin.com/in/daniel-briffa</a>',
  email: '<a href="mailto:danielbriffa@live.com">danielbriffa@live.com</a>',
  mobile: '<a href="tel:+356 79256580">+356 79256580</a>'
};
